import script from "./AppConsentPlaceholder.vue?vue&type=script&setup=true&lang=js"
export * from "./AppConsentPlaceholder.vue?vue&type=script&setup=true&lang=js"

import "./AppConsentPlaceholder.vue?vue&type=style&index=0&id=11084335&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11084335"]])

export default __exports__